<template>
  <div>
    <div v-if="['super_admin', 'admin'].includes(currentUser.active_team_role)">
      <div class="page-title">Edit Project</div>
      <Form
        v-if="form"
        v-model="form"
        :submit="update"
        btnText="Update Project"
      />
      <Spinner v-else />
    </div>
    <div v-else>
      <div class="page-title">Project</div>
      <div>
        You don't have access to the project settings. Please, contact your
        admin to get more details.
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./_form.projects.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}” Project` : `Edit Project`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async update({ onUploadProgress }) {
      await this.$api.Project.update(this.form, { onUploadProgress });
      this.$router.push("/projects");
    },
    async setForm() {
      const { data } = await this.$api.Project.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
  },
};
</script>

<style></style>
